import { render, staticRenderFns } from "./rule8.vue?vue&type=template&id=1735978e&scoped=true"
import script from "./rule8.vue?vue&type=script&lang=js"
export * from "./rule8.vue?vue&type=script&lang=js"
import style0 from "./rule8.vue?vue&type=style&index=0&id=1735978e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1735978e",
  null
  
)

export default component.exports